import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-message-filled-stroke",
  "use": "foquz-icon-message-filled-stroke-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-message-filled-stroke\"><path d=\"M2.5 10.5h2v2a.782.782 0 001.244.63h0l.008-.006L9.17 10.5h2.33c1.103 0 2-.896 2-2v-6c0-1.104-.897-2-2-2h-9a2 2 0 00-2 2v6a2 2 0 002 2z\" fill=\"#73808D\" stroke=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol